import {setFWUFinished, setFWUProgress} from '../../state/ducks/iotDevice/actions';
import {dispatch} from '../../state/store';
import dateTimeUtils from '../../utils/dateTimeUtils';
import mwMessageRequestService from '../iot/mwMessageRequestService';
import log from '../logger/log';
import userBrowserService from '../user/userBrowserService';
import framesProcessingService from './framesProcessingService';
import fwuTargetService from './fwuTargetService';

// TODO: add for holder fwu
export default class BaseFwuClient {
    constructor({fwuPackageData, fwu_target}) {
        this.fwuPackageData = fwuPackageData;
        this.fwu_target = fwu_target;

        this.currentEventType = undefined;
    }

    startTs;

    setStartTs = () => {
        this.startTs = dateTimeUtils.getNowUtcTsUnix();
    };

    onFwuErrorBase = (props) => {
        log.info('BaseFwuClient: onFwuErrorBase is called');
        framesProcessingService.restart();
        this.publishFwuError(props);
    };

    onFwuFinishBase = () => {
        log.info('BaseFwuClient: onFwuFinishBase is called');
        framesProcessingService.restart();
        this.publishFwuFinish();
        dispatch(setFWUFinished());
    };

    onFwuStopBase = () => {
        framesProcessingService.restart();
    };

    publishFwuError = ({errorCode, lastRequestFrames, lastResponseFrames, errorFrame}) => {
        mwMessageRequestService.onFwuErrorHandler({
            errorCode,
            errorFrame,
            eventType: this.currentEventType,
            fwu_target: this.fwu_target,
            lastRequestFrames,
            lastResponseFrames,
            onError: this.onFwuError,
            startTs: this.startTs,
            userAgent: userBrowserService.getUserAgent(),
        });
    };

    publishFwuFinish = () => {
        mwMessageRequestService.publishFwuFinishEvent({
            fwu_target: this.fwu_target,
            onSuccess: this.onFwuFinish,
            startTs: this.startTs,
        });
    };

    sendStatusMessage = (status) => {
        if (status) {
            mwMessageRequestService.onFwuStatusEvent({
                onSuccess: this.onFwuStatusEvent,
                status,
                fwu_target: this.fwu_target,
            });

            const {
                status: {progress},
            } = status;

            dispatch(setFWUProgress(progress));
        }
    };

    isFwuHolderRelatedTarget = () => fwuTargetService.isFwuTargetHolderRelated(this.fwu_target);
}
